// extracted by mini-css-extract-plugin
module.exports = {"container":"noteBox_container__3ylI8"};